export const municipalityFromDto = (dto) => ({
  id: dto.id,
  name: dto.name,
  code: dto.code,
  departmentId: dto.departament,
  departmentName: dto.departament_name,
});